import { render, staticRenderFns } from "./goodsShelf.vue?vue&type=template&id=124b359a&scoped=true"
import script from "./goodsShelf.vue?vue&type=script&lang=js"
export * from "./goodsShelf.vue?vue&type=script&lang=js"
import style0 from "./goodsShelf.vue?vue&type=style&index=0&id=124b359a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b359a",
  null
  
)

export default component.exports